import { render, staticRenderFns } from "./AccountCompensation.html?vue&type=template&id=9d63d28a&scoped=true&"
import script from "./AccountCompensation.ts?vue&type=script&lang=ts&"
export * from "./AccountCompensation.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_compensation.scss?vue&type=style&index=0&id=9d63d28a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d63d28a",
  null
  
)

export default component.exports